/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.getUnreadCount'

export { $nsid }

/** Count the number of unread notifications for the requesting account. Requires auth. */
const main = l.query(
  $nsid,
  l.params({
    priority: l.optional(l.boolean()),
    seenAt: l.optional(l.string({ format: 'datetime' })),
  }),
  l.jsonPayload({ count: l.integer() }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
